import { IWorkItem, IWorkItemWithConversation } from '@dxp/core/models';
import { MediaType, TaskOrder } from '@dxp/core/types';

export function sortWorkItemsByMediaAndTime(items: IWorkItem[]): IWorkItem[] {
    return [...items].sort((a, b) => {
        const mediaA = mediaTypeMapping(a);
        const mediaB = mediaTypeMapping(b);

        if (mediaA === mediaB) {
            return a.createdAt.getTime() - b.createdAt.getTime();
        }

        return mediaA - mediaB;
    });
}

const mediaTypeMapping = (
    workitem: IWorkItem | IWorkItemWithConversation,
): TaskOrder => {
    const mediaType =
        (workitem as IWorkItem).primaryMediaType ??
        (workitem as IWorkItemWithConversation).mediaType;

    return mediaTypeMappings[mediaType] ?? TaskOrder.Unknown;
};

const mediaTypeMappings: Partial<Record<MediaType, TaskOrder>> = {
    Voice: TaskOrder.Voice,
    Webchat: TaskOrder.Webchat,
    Messaging: TaskOrder.Messaging,
    Email: TaskOrder.Email,
};
